import React, { useContext, useState } from "react";
import { Button } from "react-bootstrap";
import signup from "../../assets/images/sighup/signup.png";
// import googleicon from "../../assets/images/sighup/social-icon.svg";
// import linkedicon from "../../assets/images/sighup/linkedin-icon.svg";
// import mailicon from "../../assets/images/sighup/mail-icon.svg";
import hide from "../../assets/images/sighup/hide-icon.svg";
import showeye from "../../assets/images/sighup/show-icon.svg";
import { Form } from "react-bootstrap";
import { useGoogleLogin } from "@react-oauth/google";
import UserContext from "../../context/UserContext";
import { authInstance } from "../../config/axios";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { LoginSchema } from "../../validationSchema/authSchema.js";
import { login } from "../../utils/Api.js";
import { toast } from "react-toastify";

const LoginPopup = ({ setLogin, setResource, setUpdateProfile }) => {
  const [show, setShow] = useState(false);
  const { user, setUser, setToken } = useContext(UserContext);

  const handlepasswordshow = () => {
    setShow(!show);
  };

  const handleGoogleSuccess = async (info) => {
    console.log("info", info);
    try {
      if (info.error) {
        return;
      }

      const profilePayload = {
        accessToken: info.access_token,
      };
      // setLoader(true);
      const res = await authInstance.post(
        "/googleLogin",
        profilePayload
        //   {withCredentials: true,
        //   credentials: "include",
        // }
      );
      const {
        status,
        data: {
          tokens: { access, refresh },
          user,
          // newUser,
        },
      } = res;
      if (status === 200) {
        //  setSignup(false)
        setLogin(false);
        setUser(user);
        setToken(access.token);
        localStorage.setItem("token", access.token);
        localStorage.setItem("userid", user?.id);
        localStorage.setItem("refreshToken", refresh?.token);
        if (user.role === "client") {
          setResource(true);
        } else {
          console.log(" I m develioper");
          setUpdateProfile(true);
        }
      }
    } catch (err) {
      console.log("errr-->", err);
    }
  };

  const loginForGoogle = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: (error) => console.log("Login Failed:", error),
  });
  return (
    <div>
      <div className='signup-popup-content'>
        <div className='signup-popup-left'>
          <SignupLeft
            show={show}
            handlepasswordshow={handlepasswordshow}
            loginForGoogle={loginForGoogle}
            setLogin={setLogin}
            user={user}
            setUser={setUser}
            setToken={setToken}
            setResource={setResource}
            setUpdateProfile={setUpdateProfile}
          />
        </div>
        <div className='signup-popup-right'>
          <img src={signup} alt='signup' />
        </div>
      </div>
    </div>
  );
};

export default LoginPopup;
const SignupLeft = ({
  show,
  handlepasswordshow,
  loginForGoogle,
  setLogin,
  user,
  setUser,
  setToken,
  setUpdateProfile,
  setResource,
}) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(LoginSchema),
  });

  const handleSignup = async (values) => {
    try {
      const res = await login(values);
      if (res.user) {
        const { tokens, user } = res;
        setLogin(false);
        setUser(user);
        setToken(tokens.access.token);
        localStorage.setItem("token", tokens.access.token);
        localStorage.setItem("refreshToken", tokens.refresh.token);
        localStorage.setItem("userid", user?.id);
        toast.success("You are successfully LogIn ");
        if (user.role === "client") {
          setResource(true);
        } else {
          console.log(" I m develioper");
          setUpdateProfile(true);
        }
      }
    } catch (error) {
      console.log("error ---->>", error);
    }
  };
  return (
    <div className='login-left-content'>
      <div className='signup-popup-text'>
        <h4>
          Sign in to your <span>account</span>
        </h4>
        <p>
          Lorem Ipsum has been the industry's standard dummy text ever since
        </p>
      </div>
      <div className='signup-input-content'>
        <Form onSubmit={handleSubmit(handleSignup)}>
          <Form.Group className='dev-input'>
            <label>Email</label>
            <Form.Control
              type='text'
              placeholder='Enter your mail name'
              name='email'
              className={errors.email ? "error-field" : ""}
              {...register("email")}
            />

            {errors?.email ? (
              <p className='error-text'>{errors.email.message}</p>
            ) : (
              ""
            )}
          </Form.Group>
          <Form.Group className='dev-input password-input'>
            <label>Password</label>
            <Form.Control
              type={show ? "text" : "password"}
              placeholder='*************'
              name='password'
              {...register("password")}
            />
            {errors?.password ? (
              <p className='error-text'>{errors.password.message}</p>
            ) : (
              ""
            )}
            <div className='password' onClick={handlepasswordshow}>
              {show ? (
                <img src={showeye} alt='eye' />
              ) : (
                <img src={hide} alt='eye' />
              )}
            </div>
          </Form.Group>
          <div className='login-forgot'>
            <div className='login-forgot-left'>
              <Form.Check className='dev-filter' type='checkbox' />
              <label>Remember me</label>
            </div>
            <div className='login-forgot-right'>
              <span>Forgot your password?</span>
            </div>
          </div>
          <Button className='cta-btn' type='submit'>
            Sign in
          </Button>
          <div className='login-account'>
            <p>
              Don’t have an account?
              <span>Sign up</span>
            </p>
          </div>
        </Form>
      </div>
    </div>
  );
};
